// src/hooks/useAutoplayOnVisible.ts
import { RefObject, useEffect } from "react";

export function useAutoplayOnVisible(
  videoRef: RefObject<HTMLVideoElement>,
  threshold = 0.5,
) {
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio >= threshold) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      },
      { threshold },
    );

    observer.observe(video);
    return () => {
      observer.disconnect();
    };
  }, [videoRef, threshold]);
}
